import React, { Component } from 'react';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Compass, Desert, NoConnection } from '../images/illustrations/no-data';

import './BlockError.scss';

class BlockError extends Component {
  illustrationFor(error) {
    switch (error) {
      case 'noassets':
        return <Compass />;
      case 'session':
        return <NoConnection />;
      default:
        return <Desert />;
    }
  }
  render() {
    const { error } = this.props;
    return (
      <div>
        <div className="illustration-container">
          {this.illustrationFor(error)}
        </div>
        <div className="error-container with-heading">
          <h2>
            <FormattedMessage id={`components.ecs.${error}.header`} />
          </h2>
          <FormattedMessage id={`components.ecs.${error}.description`} />
        </div>
      </div>
    );
  }
}

BlockError.propTypes = {
  error: PropTypes.string.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(BlockError);
